import { ResellDocument } from '../../../../types';

export type SortOption = {
  label: string;
  value: string;
};

export type SortField = 'folio' | 'monto' | 'cliente' | 'deudor';
export type SortOrder = 'asc' | 'desc';

export const SORT_OPTIONS: SortOption[] = [
  { label: 'Folio', value: 'folio' },
  { label: 'Monto Documento', value: 'monto' },
  { label: 'Cliente', value: 'cliente' },
  { label: 'Deudor', value: 'deudor' },
];

export const SORT_ORDER_OPTIONS: SortOption[] = [
  { label: 'Ascendente', value: 'asc' },
  { label: 'Descendente', value: 'desc' },
];

export const sortResells = (
  resells: ResellDocument[],
  sortField: SortField,
  sortOrder: SortOrder = 'desc',
): ResellDocument[] => {
  const sorted = [...resells];

  sorted.sort((a, b) => {
    let comparison = 0;
    switch (sortField) {
      case 'folio':
        comparison = a.folio.localeCompare(b.folio, undefined, {
          numeric: true,
        });
        break;
      case 'monto':
        comparison = (a.originalAmount || 0) - (b.originalAmount || 0);
        break;
      case 'cliente':
        comparison = (a.businessName || '').localeCompare(b.businessName || '');
        break;
      case 'deudor':
        comparison = (a.stakeholderName || '').localeCompare(
          b.stakeholderName || '',
        );
        break;
      default:
        return 0;
    }
    return sortOrder === 'desc' ? -comparison : comparison;
  });

  return sorted;
};

export const isValidSortField = (value: string): value is SortField => {
  return (
    value === 'folio' ||
    value === 'monto' ||
    value === 'cliente' ||
    value === 'deudor'
  );
};

export const getDefaultSortField = (): SortField => {
  return 'folio';
};

export const getDefaultSortOrder = (): SortOrder => {
  return 'desc';
};

export const isValidSortOrder = (value: string): value is SortOrder => {
  return value === 'asc' || value === 'desc';
};
